export enum RouteNames {
  NOT_FOUND = "not-found",
  UNAUTHORIZED = "unauthorized",
  SURF_CONEXT_UNAUTHORIZED = "surf-conext-unauthorized",
  ACCOUNTS = "accounts",
  ACCOUNT = "account",
  ACCOUNT_CREATE = "account-create",
  TENANTS = "tenants",
}
